import { userModelData } from './models/AdminUserModel'
import { AdminUserService } from './api/AdminUserService'

const UserModule = {
  namespaced: true, // NameSpaced module
  state: userModelData(),
  getters: {
    fetchUserList: state => state.userList,
    getSuccess: state => state.success
  },
  mutations: {
    setList (state, data) {
      state.userList = data.list.list
    },
    deleteUser (state, payload) {
      state.userList.splice(payload.id, 1)
    }
  },
  actions: {

    /**
     * Attempt Login action handler
     *
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param credentials | object
     */
    async getUserList ({ commit }, { resolve, reject }) {
      try {
        const response = await AdminUserService.fetchUserList()
        const { success, data } = response.data
        if (success === true) {
          commit('setList', {
            list: response.data.data
          })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async addAdminUser ({ dispatch }, { resolve, reject, formData }) {
      try {
        const response = await AdminUserService.addAdminUser(formData)
        const { success, data } = response.data
        if (success) {
          dispatch('getUserList', { resolve, reject })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async editAdminUser ({ dispatch }, { resolve, reject, editedData }) {
      try {
        const response = await AdminUserService.editAdminUser(editedData)
        const { success, data } = response.data // add error flag here
        if (success) {
          dispatch('getUserList', { resolve, reject })
          resolve && resolve(data)
        } else {
          reject && reject(data) // there should be error flag
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async validateAdminUser ({ dispatch }, { resolve, reject, formData }) {
      try {
        const response = await AdminUserService.validateAdminUser(formData)
        const { success, data } = response.data
        if (success === true) {
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async deleteAdminUser ({ dispatch, commit }, { resolve, reject, formData }) {
      try {
        const response = await AdminUserService.deleteAdminUser(formData)
        const { success, data } = response.data
        if (success === true) {
          commit('deleteUser', { formData })
          dispatch('getUserList', { resolve, reject })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    }
  }
}

export default UserModule
